// Shared token + chain data for DEX automation pages (Limit Orders, DCA).
// Single source of truth — both pages import from here so the curated lists
// don't drift apart.

export const CHAINS = [
  { id: 1,     label: 'Ethereum' },
  { id: 137,   label: 'Polygon' },
  { id: 42161, label: 'Arbitrum' },
  { id: 8453,  label: 'Base' },
  { id: 56,    label: 'BSC' },
  { id: 10,    label: 'Optimism' },
  { id: 43114, label: 'Avalanche' },
];

// Per-protocol chain coverage. CoW supports 3 mainstream chains; Velora
// covers all 7 + Gnosis. UI filters the network dropdown to whichever
// protocol is selected. (1inch entry kept so old stored records render with
// a recognisable label, but it's no longer surfaced in the UI selector.)
export const PROTOCOL_CHAINS = {
  'cow':    [1, 42161, 8453],
  'velora': [1, 137, 42161, 8453, 56, 10, 43114],
  '1inch':  [1, 137, 42161, 8453, 56, 10, 43114],
};

// Curated token lists — top tokens by liquidity + DEX volume on each chain.
// Users can paste any other ERC-20 via the custom-token input.
// Every entry: { symbol, address, decimals }. Addresses are checksummed.
export const TOKENS_BY_CHAIN = {
  1: [ // Ethereum
    { symbol: 'WETH', address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', decimals: 18 },
    { symbol: 'USDC', address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', decimals: 6  },
    { symbol: 'USDT', address: '0xdAC17F958D2ee523a2206206994597C13D831ec7', decimals: 6  },
    { symbol: 'WBTC', address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599', decimals: 8  },
    { symbol: 'DAI',  address: '0x6B175474E89094C44Da98b954EedeAC495271d0F', decimals: 18 },
    { symbol: 'LINK', address: '0x514910771AF9Ca656af840dff83E8264EcF986CA', decimals: 18 },
    { symbol: 'UNI',  address: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984', decimals: 18 },
    { symbol: 'AAVE', address: '0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9', decimals: 18 },
    { symbol: 'MATIC',address: '0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0', decimals: 18 },
    { symbol: 'SHIB', address: '0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE', decimals: 18 },
    { symbol: 'PEPE', address: '0x6982508145454Ce325dDbE47a25d4ec3d2311933', decimals: 18 },
    { symbol: 'LDO',  address: '0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32', decimals: 18 },
    { symbol: 'CRV',  address: '0xD533a949740bb3306d119CC777fa900bA034cd52', decimals: 18 },
    { symbol: 'MKR',  address: '0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2', decimals: 18 },
    { symbol: 'COMP', address: '0xc00e94Cb662C3520282E6f5717214004A7f26888', decimals: 18 },
    { symbol: 'SNX',  address: '0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F', decimals: 18 },
    { symbol: 'GRT',  address: '0xc944E90C64B2c07662A292be6244BDf05Cda44a7', decimals: 18 },
    { symbol: 'ENS',  address: '0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72', decimals: 18 },
    { symbol: 'APE',  address: '0x4d224452801ACEd8B2F0aebE155379bb5D594381', decimals: 18 },
    { symbol: 'BLUR', address: '0x5283D291DBCF85356A21bA090E6db59121208b44', decimals: 18 },
  ],
  137: [ // Polygon
    { symbol: 'WMATIC', address: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270', decimals: 18 },
    { symbol: 'USDC',   address: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359', decimals: 6  },
    { symbol: 'USDC.e', address: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174', decimals: 6  },
    { symbol: 'USDT',   address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F', decimals: 6  },
    { symbol: 'WETH',   address: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619', decimals: 18 },
    { symbol: 'WBTC',   address: '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6', decimals: 8  },
    { symbol: 'DAI',    address: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063', decimals: 18 },
    { symbol: 'LINK',   address: '0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39', decimals: 18 },
    { symbol: 'AAVE',   address: '0xD6DF932A45C0f255f85145f286eA0b292B21C90B', decimals: 18 },
    { symbol: 'UNI',    address: '0xb33EaAd8d922B1083446DC23f610c2567fB5180f', decimals: 18 },
    { symbol: 'CRV',    address: '0x172370d5Cd63279eFa6d502DAB29171933a610AF', decimals: 18 },
    { symbol: 'GHST',   address: '0x385Eeac5cB85A38A9a07A70c73e0a3271CfB54A7', decimals: 18 },
  ],
  42161: [ // Arbitrum
    { symbol: 'WETH', address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1', decimals: 18 },
    { symbol: 'USDC', address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831', decimals: 6  },
    { symbol: 'USDC.e', address: '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8', decimals: 6 },
    { symbol: 'USDT', address: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9', decimals: 6  },
    { symbol: 'ARB',  address: '0x912CE59144191C1204E64559FE8253a0e49E6548', decimals: 18 },
    { symbol: 'WBTC', address: '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f', decimals: 8  },
    { symbol: 'DAI',  address: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1', decimals: 18 },
    { symbol: 'LINK', address: '0xf97f4df75117a78c1A5a0DBb814Af92458539FB4', decimals: 18 },
    { symbol: 'UNI',  address: '0xFa7F8980b0f1E64A2062791cc3b0871572f1F7f0', decimals: 18 },
    { symbol: 'GMX',  address: '0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a', decimals: 18 },
    { symbol: 'MAGIC',address: '0x539bdE0d7Dbd336b79148AA742883198BBF60342', decimals: 18 },
    { symbol: 'PENDLE',address:'0x0c880f6761F1af8d9Aa9C466984b80DAb9a8c9e8', decimals: 18 },
  ],
  8453: [ // Base
    { symbol: 'WETH',  address: '0x4200000000000000000000000000000000000006', decimals: 18 },
    { symbol: 'USDC',  address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913', decimals: 6  },
    { symbol: 'USDbC', address: '0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA', decimals: 6  },
    { symbol: 'DAI',   address: '0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb', decimals: 18 },
    { symbol: 'cbETH', address: '0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22', decimals: 18 },
    { symbol: 'cbBTC', address: '0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf', decimals: 8  },
    { symbol: 'AERO',  address: '0x940181a94A35A4569E4529A3CDfB74e38FD98631', decimals: 18 },
    { symbol: 'DEGEN', address: '0x4ed4E862860beD51a9570b96d89aF5E1B0Efefed', decimals: 18 },
  ],
  56: [ // BSC — 1inch only
    { symbol: 'WBNB', address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c', decimals: 18 },
    { symbol: 'USDT', address: '0x55d398326f99059fF775485246999027B3197955', decimals: 18 },
    { symbol: 'USDC', address: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d', decimals: 18 },
    { symbol: 'BUSD', address: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56', decimals: 18 },
    { symbol: 'CAKE', address: '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82', decimals: 18 },
    { symbol: 'WETH', address: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8', decimals: 18 },
    { symbol: 'BTCB', address: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c', decimals: 18 },
    { symbol: 'DAI',  address: '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3', decimals: 18 },
  ],
  10: [ // Optimism — 1inch only
    { symbol: 'WETH', address: '0x4200000000000000000000000000000000000006', decimals: 18 },
    { symbol: 'USDC', address: '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85', decimals: 6  },
    { symbol: 'USDT', address: '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58', decimals: 6  },
    { symbol: 'OP',   address: '0x4200000000000000000000000000000000000042', decimals: 18 },
    { symbol: 'WBTC', address: '0x68f180fcCe6836688e9084f035309E29Bf0A2095', decimals: 8  },
    { symbol: 'DAI',  address: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1', decimals: 18 },
    { symbol: 'LINK', address: '0x350a791Bfc2C21F9Ed5d10980Dad2e2638ffa7f6', decimals: 18 },
    { symbol: 'SNX',  address: '0x8700dAec35aF8Ff88c16BdF0418774CB3D7599B4', decimals: 18 },
  ],
  43114: [ // Avalanche C-chain — 1inch only
    { symbol: 'WAVAX', address: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7', decimals: 18 },
    { symbol: 'USDC',  address: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E', decimals: 6  },
    { symbol: 'USDT',  address: '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7', decimals: 6  },
    { symbol: 'WETH.e',address: '0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB', decimals: 18 },
    { symbol: 'BTC.b', address: '0x152b9d0FdC40C096757F570A51E494bd4b943E50', decimals: 8  },
    { symbol: 'DAI.e', address: '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70', decimals: 18 },
    { symbol: 'JOE',   address: '0x6e84a6216eA6dACC71eE8E6b0a5B7322EEbC0fDd', decimals: 18 },
  ],
};

// localStorage key per chain for user-resolved custom tokens (so they persist
// across refreshes within a session).
function customKey(chainId) { return `dex_custom_tokens_${chainId}`; }

export function loadCustomTokens(chainId) {
  try {
    const raw = localStorage.getItem(customKey(chainId));
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch { return []; }
}

export function saveCustomToken(chainId, token) {
  if (!token?.address) return;
  const existing = loadCustomTokens(chainId);
  if (existing.find(t => t.address.toLowerCase() === token.address.toLowerCase())) return;
  const next = [...existing, token];
  try { localStorage.setItem(customKey(chainId), JSON.stringify(next)); } catch {}
}

// Map a DEX trading pair to a TradingView chart symbol. TV's free widget
// pulls from CEX price feeds (Binance/Coinbase/etc.); since the underlying
// asset price is the same whether you trade on a CEX or DEX, this gives
// users a real reference even though their order settles on-chain.
const STABLES = ['USDC', 'USDT', 'DAI', 'USDbC', 'USDC.e', 'BUSD'];
const UNWRAP = { WETH: 'ETH', WBTC: 'BTC', WMATIC: 'MATIC', WBNB: 'BNB', WAVAX: 'AVAX', 'BTC.b': 'BTC', 'WETH.e': 'ETH', cbETH: 'ETH', cbBTC: 'BTC' };
export function chartPairFor(sellSym, buySym) {
  if (!sellSym || !buySym) return 'ETH/USDT';
  const sellIsStable = STABLES.includes(sellSym);
  const buyIsStable  = STABLES.includes(buySym);
  const norm = (s) => UNWRAP[s] || s;
  if (sellIsStable && !buyIsStable)  return `${norm(buySym)}/USDT`;
  if (!sellIsStable && buyIsStable)  return `${norm(sellSym)}/USDT`;
  return `${norm(buySym)}/USDT`;
}

// Combine curated + user-resolved customs for a chain. Customs come last so
// curated/audited tokens lead the dropdown.
export function getTokensFor(chainId) {
  const curated = TOKENS_BY_CHAIN[chainId] || [];
  const customs = loadCustomTokens(chainId).map(t => ({ ...t, custom: true }));
  // Dedupe by address — curated wins
  const seen = new Set(curated.map(t => t.address.toLowerCase()));
  const dedupedCustoms = customs.filter(t => !seen.has(t.address.toLowerCase()));
  return [...curated, ...dedupedCustoms];
}
